
import React, { Component } from 'react';
import { Checkbox } from 'antd';

export class Certificate extends Component {

    handleCertificateStatus = (value) => {
        const { onChange } = this.props;
        onChange(value);
    }

    render() {
        const { value, disabled } = this.props;
        return (
            <div className="certificate-status">
                <Checkbox
                    disabled={disabled}
                    onChange={() => this.handleCertificateStatus(true)}
                    checked={value === true}
                >
                    Có
                </Checkbox>
                <Checkbox 
                    disabled={disabled}
                    onChange={() => this.handleCertificateStatus(false)}
                    checked={value === false}
                >
                    Không</Checkbox>
            </div>
        )
    }
}